module.exports = __webpack_public_path__ + "b5e52f2fb486d28f8d9446f074d1e88d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/greetings/wave.png
// module id = 3225
// module chunks = 0